class SliderSection extends HTMLElement {
  autoSlideInterval = null;
  autoSlideTimeout = null;
  isUserInteracting = false;
  constructor() {
    super();
  }
  connectedCallback() {
    const slider = this;
    const scrollContainer = slider.closest(".scroll-container");
    const sliderCards = Array.from(slider.querySelectorAll(".slide"));
    const sliderCardsWidth = sliderCards.length > 0 ? sliderCards[0].offsetWidth + 12 : 0;
    const sliderBtns = Array.from((scrollContainer.closest(".slider-section") ?? scrollContainer).querySelectorAll(".sliderbtn"));
    sliderBtns.forEach((sliderBtn) => {
      sliderBtn.addEventListener("click", () => {
        const direction = sliderBtn.getAttribute("data-id");
        if (direction === "right") {
          slider.scrollLeft += sliderCardsWidth;
        } else if (direction === "left") {
          slider.scrollLeft -= sliderCardsWidth;
        }
      });
    });
    if (this.getAttribute("data-type-auto-slide") === "true") {
      this.startAutoSlide(slider, sliderCardsWidth);
      scrollContainer.addEventListener("mouseenter", () => {
        this.stopAutoSlide();
        this.isUserInteracting = true;
      });
      scrollContainer.addEventListener("mouseleave", () => {
        this.isUserInteracting = false;
        this.startAutoSlide(slider, sliderCardsWidth);
      });
      scrollContainer.addEventListener("scroll", () => {
        if (!this.isUserInteracting) {
          this.stopAutoSlide();
          clearTimeout(this.autoSlideTimeout);
          this.autoSlideTimeout = setTimeout(() => {
            if (!this.isUserInteracting) {
              this.startAutoSlide(slider, sliderCardsWidth);
            }
          }, 2e3);
        }
      });
    }
  }
  startAutoSlide(sliderElement, slideWidth) {
    const slideDelay = parseInt(this.getAttribute("data-slide-delay") || "3000", 10);
    this.autoSlideInterval = setInterval(() => {
      const maxScrollLeft = sliderElement.scrollWidth - sliderElement.clientWidth;
      if (sliderElement.scrollLeft + slideWidth >= maxScrollLeft) {
        sliderElement.scrollLeft = 0;
      } else {
        sliderElement.scrollLeft += slideWidth;
      }
    }, slideDelay);
  }
  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }
  disconnectedCallback() {
    this.stopAutoSlide();
  }
}
customElements.define("slider-section", SliderSection);
